import { PredefinedMessagePlaceholderModel } from "../schema";

export class PredefinedMessagePlaceholderContainer{
    predefined_message_placeholder: PredefinedMessagePlaceholderModel
}